import { Typography } from "@material-ui/core";
import moment from "moment";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";
import { sanitizeHtml } from "../utils/sanitizeHtml";

const ViewJob = ({ jobToView }) => {
    const safeBody = sanitizeHtml(jobToView?.body);

    return (
        <div>
            <Typography variant="h3">
                {jobToView.title.charAt(0).toUpperCase() + jobToView.title.slice(1)}
            </Typography>

            <p style={{ margin: "10px 0px" }}>
                Posted by{" "}
                <span
                    style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "rgb(151, 150, 150)",
                    }}
                >
                    {jobToView.author}
                </span>{" "}
                | Published{" "}
                <span
                    style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "rgb(151, 150, 150)",
                    }}
                >
                    {moment(jobToView.createdAt).fromNow()}
                </span>
            </p>
            <ReactQuill readOnly={true} value={safeBody} theme="bubble" />
        </div>
    );
};

export default ViewJob;
